import { isEmpty } from 'lodash';

import useWizardContext from '@swf/core/hooks/useWizardContext';

const useDisableField = () => {
  const {
    data: { userInfoFields }
  } = useWizardContext();

  return (fieldId: string) => {
    if (isEmpty(userInfoFields)) {
      return false;
    }

    const field = userInfoFields?.find(({ name }) => name === fieldId);

    return !!field && !field.editable;
  };
};

export default useDisableField;
